<template>
	<picture>
		<source :srcset="staticUrl + '/images/logo-' + prefix + width + '.webp'" type="image/webp"/>
		<img
			:src="staticUrl + '/images/logo-' + prefix + width + '.png'"
			title="CrossFit® Limouzi"
			:width="width"
			:height="height"
			alt="CrossFit® Limouzi"/>
	</picture>
</template>

<script lang="ts" setup>
	const props = defineProps<{
		width: "150" | "300" | "500" | "1000",
		coach?: boolean,
		volunteer?: boolean
	}>();

	// @ts-ignore
	const staticUrl = import.meta.env.VITE_STATIC_URL;
	const prefix = props.coach ? "coach-" : props.volunteer ? "volunteer-" : "";
	let height: any;

	if (props.width == "1000")
	{
		height = "854";
	}
	else if (props.width == "500")
	{
		height = "427";
	}
	else if (props.width == "300")
	{
		height = "256";
	}
	else if (props.width == "150")
	{
		height = "128";
	}
</script>

<style scoped>
	@reference "@main-css";

	img {
		@apply focus-visible:outline-0;
	}
</style>
